import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import queryString from 'query-string'
import { MenuPlaceholder } from 'src/components/Placeholders/MenuPlaceholder'
import { Spinner } from 'src/Throbber'
import { NONE_ID } from 'src/Utils/globalConstants'
import { ChevronSVG } from 'src/components/Icons/Basic'
import { useNavigateContext } from '../../../Navigation/NavigateContext'
import { FilterDropdownToggle } from '../FilterBar.styles'
import { DropDownMenu, NestedDropdownMenu } from './FilterDropdown.styles'
import { MultiSelectDropdownItems } from './FilterDropdown'
import { DropdownItemType } from './FilterDropdown.constants'
import { EnsureParent } from './FilterDropdown.types'

export const NestedFilter = ({
  filterParam,
  filterValues,
  ensureParent,
}: {
  filterParam: string
  filterValues: DropdownItemType[]
  ensureParent?: EnsureParent
}): JSX.Element => {
  const location = useLocation()
  const searchParamsFallback = queryString.parse(location.search, {
    arrayFormat: 'bracket',
  })
  const {
    navigateState: {
      parsedQueryParams,
      locationSearchString: contextLocationSearchString,
    },
  } = useNavigateContext()
  const searchParams = parsedQueryParams || searchParamsFallback
  const locationSearchString = contextLocationSearchString ?? location.search

  const appliedFilters = useMemo(() => {
    const appliedFilters: Record<string, string[]> = {}
    const preprocessed = searchParams[filterParam]
    if (Array.isArray(preprocessed)) {
      appliedFilters[filterParam] = preprocessed
    } else {
      appliedFilters[filterParam] = preprocessed ? [preprocessed] : []
    }
    return appliedFilters
  }, [searchParams, filterParam])

  return (
    <NestedDropdownMenu>
      <MultiSelectDropdownItems
        filterParam={filterParam}
        filterValues={filterValues}
        appliedFilters={appliedFilters}
        location={location}
        searchParams={searchParams}
        activeSubmenu={NONE_ID}
        setActiveSubmenu={() => NONE_ID}
        locationSearchString={locationSearchString}
        ensureParent={ensureParent}
      />
    </NestedDropdownMenu>
  )
}

export const LoadingFilterDropdown = ({
  filterName,
  customName,
  isNested,
}: {
  filterName: string
  customName?: string
  isNested?: boolean
}): JSX.Element => (
  <>
    <Dropdown.Toggle
      as={FilterDropdownToggle}
      id={`${filterName}-filter-dropdown`}
      $isNested={isNested}
    >
      <p>{customName || filterName}</p>
      <Spinner size="s" color="primary" mx="xxs" />
    </Dropdown.Toggle>
    <DropDownMenu>
      <MenuPlaceholder height={108} />
    </DropDownMenu>
  </>
)

export const NestedFilterChevron = ({
  isOpen,
}: {
  isOpen?: boolean
}): JSX.Element => (
  <ChevronSVG
    width="12"
    height="12"
    fill="fill.primary.dark"
    style={{
      transform: `rotate(${isOpen ? '180deg' : '0'})`,
      margin: '8px',
    }}
  />
)
